<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/npkmYh/tc-custom/cover.jpg?1684515194193?1705580356519" alt="This image is the cover for the book Canciones de Amor Americanas"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Canciones de Amor Americanas
      </h1>
      <p class="bookDescription body article font2">
        <p>Jake Brenner está gozando demasiado de su libertad como para enamorarse, o eso es lo que él dice. Además, está muy ocupado con su banda, los Hijos Pródigos, para ir en busca de romance. Su reticencia no tiene nada que ver con su embarazoso amor platónico por Chris, el líder vocal de la banda y antiguo mejor amigo. Pero eso fue antes de que el enigmático vagabundo, Parker McAvoy, se uniera a la banda como el nuevo guitarrista principal.</p> <p>Jake niega su atracción hacia el dulce y torpe Parker, hasta que le es imposible ignorar la necesidad de hacer algo al respecto. El problema es que Parker lo sabe todo acerca de sus hábitos libertinos, ah, y por supuesto, no es gay. O por lo menos eso es lo que Jake piensa hasta que una serie de eventos relacionados, le proporciona una nueva perspectiva alentadora. ¿Podrá convencer a Parker de pasar por alto su pasado colorido para darle una oportunidad? ¿O esta canción de amor se desvanecerá incluso antes de que comience?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ashlyn Kane, L.A. Aguilar
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?ef66b26a